export default __webpack_public_path__ + "static/media/stopwatch.4a5d3732.svg";